module.exports = __webpack_public_path__ + "img/mail.976115cf.png";